import React, { Component } from "react"
import ReactEcharts from "echarts-for-react"
import { Row, Col } from "reactstrap"

class FuelConsumptionChart extends Component<any> {
    FuelConsumption = () => {
        let FuelConsumptionArray: any[] = [
            {
                type: 'At Sea',
                fo_consumption: 0,
                do_consumption: 0,
                total: 0
            },
            {
                type: 'In Port',
                fo_consumption: 0,
                do_consumption: 0,
                total: 0
            }
        ];

        this.props.pieChartData.map((data: any) => {
            if (data.vessel_position_id === 1) {
                FuelConsumptionArray[1].fo_consumption = FuelConsumptionArray[1].fo_consumption + data.fo_fuel_consumption;
                FuelConsumptionArray[1].do_consumption = FuelConsumptionArray[1].do_consumption + data.do_fuel_consumption;
                FuelConsumptionArray[1].total = FuelConsumptionArray[1].fo_consumption + FuelConsumptionArray[1].do_consumption;
            } else {
                FuelConsumptionArray[0].fo_consumption = FuelConsumptionArray[0].fo_consumption + data.fo_fuel_consumption;
                FuelConsumptionArray[0].do_consumption = FuelConsumptionArray[0].do_consumption + data.do_fuel_consumption;
                FuelConsumptionArray[0].total = FuelConsumptionArray[0].fo_consumption + FuelConsumptionArray[0].do_consumption;
            }
            return '';
        })
        return {
            toolbox: {
                show: false,
            },
            tooltip: {
                trigger: "item",
                formatter: (params: any) => `${params.seriesName} <br/>${params.data.name} : ${params.percent}% (${(params.data.value).toFixed(2)} mt)`,
            },
            legend: {
                orient: "vertical",
                left: "left",
                data: FuelConsumptionArray.map((data: any) => {
                    return (data.type.toString())
                }),
                // textStyle: {
                //   color: ["#858d98"],
                // },
            },
            color: ['#ff8d36', '#d01f1f'],
            series: [
                {
                    name: "Fuel consumption",
                    type: "pie",
                    radius: "55%",
                    center: ["50%", "60%"],
                    data: FuelConsumptionArray.map((data: any) => {
                        return {
                            value: data.total,
                            name: data.type
                        }
                    })
                    ,
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: "rgba(0, 0, 0, 0.5)",
                        },
                    },
                },
            ],
        }
    }
    inPortOp = () => {
        let FuelConsumptionArray: any[] = [
            {
                type: 'At Sea',
                fo_consumption: 0,
                do_consumption: 0,
                total: 0
            },
            {
                type: 'In Port',
                fo_consumption: 0,
                do_consumption: 0,
                total: 0
            }
        ];

        this.props.pieChartData.map((data: any) => {
            if (data.vessel_position_id === 1) {
                FuelConsumptionArray[1].fo_consumption = FuelConsumptionArray[1].fo_consumption + data.fo_fuel_consumption;
                FuelConsumptionArray[1].do_consumption = FuelConsumptionArray[1].do_consumption + data.do_fuel_consumption;
                FuelConsumptionArray[1].total = FuelConsumptionArray[1].fo_consumption + FuelConsumptionArray[1].do_consumption;
            } else {
                FuelConsumptionArray[0].fo_consumption = FuelConsumptionArray[0].fo_consumption + data.fo_fuel_consumption;
                FuelConsumptionArray[0].do_consumption = FuelConsumptionArray[0].do_consumption + data.do_fuel_consumption;
                FuelConsumptionArray[0].total = FuelConsumptionArray[0].fo_consumption + FuelConsumptionArray[0].do_consumption;
            }
            return '';
        })

        return {
            toolbox: {
                show: false,
            },
            tooltip: {
                trigger: "item",
                formatter: (params: any) => `${params.seriesName} <br/>${params.data.name} : ${params.percent}% (${(params.data.value).toFixed(2)} mt)`,
            },
            legend: {
                orient: "vertical",
                left: "left",
                data: ['FO', 'DO'],
                // textStyle: {
                //   color: ["#858d98"],
                // },
            },
            color: ['#ff8b1f', '#f76719'],
            series: [
                {
                    name: "Fuel consumption- In port",
                    type: "pie",
                    radius: "55%",
                    center: ["50%", "60%"],
                    data: [
                        {
                            value: FuelConsumptionArray[1].fo_consumption,
                            name: 'FO'
                        },
                        {
                            value: FuelConsumptionArray[1].do_consumption,
                            name: 'DO'
                        }
                    ],
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: "rgba(0, 0, 0)",
                        },
                    },
                },
            ],
        }
    }
    atSeaOp = () => {
        let FuelConsumptionArray: any[] = [
            {
                type: 'At Sea',
                fo_consumption: 0,
                do_consumption: 0,
                total: 0
            },
            {
                type: 'In Port',
                fo_consumption: 0,
                do_consumption: 0,
                total: 0
            }
        ];

        this.props.pieChartData.map((data: any) => {
            if (data.vessel_position_id === 1) {
                FuelConsumptionArray[1].fo_consumption = FuelConsumptionArray[1].fo_consumption + data.fo_fuel_consumption;
                FuelConsumptionArray[1].do_consumption = FuelConsumptionArray[1].do_consumption + data.do_fuel_consumption;
                FuelConsumptionArray[1].total = FuelConsumptionArray[1].fo_consumption + FuelConsumptionArray[1].do_consumption;
            } else {
                FuelConsumptionArray[0].fo_consumption = FuelConsumptionArray[0].fo_consumption + data.fo_fuel_consumption;
                FuelConsumptionArray[0].do_consumption = FuelConsumptionArray[0].do_consumption + data.do_fuel_consumption;
                FuelConsumptionArray[0].total = FuelConsumptionArray[0].fo_consumption + FuelConsumptionArray[0].do_consumption;
            }
            return '';
        })

        return {
            toolbox: {
                show: false,
            },
            tooltip: {
                trigger: "item",
                formatter: (params: any) => `${params.seriesName} <br/>${params.data.name} : ${params.percent}% (${(params.data.value).toFixed(2)} mt)`,
            },
            legend: {
                orient: "vertical",
                left: "left",
                data: ["FO", "DO"],
                // textStyle: {
                //   color: ["#858d98"],
                // },
            },
            color: ['#f45e5e', '#a30001'],
            series: [
                {
                    name: "Fuel consumption- At sea",
                    type: "pie",
                    radius: "55%",
                    center: ["50%", "60%"],
                    data: [
                        {
                            value: FuelConsumptionArray[0].fo_consumption,
                            name: 'FO'
                        },
                        {
                            value: FuelConsumptionArray[0].do_consumption,
                            name: 'DO'
                        }
                    ],
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: "rgba(0, 0, 0)",
                        },
                    },
                },
            ],
        }
    }
    render() {
        return (
            <React.Fragment>
                <Row>
                    <Col lg={4}>
                        <strong>Fuel consumption</strong>
                        <ReactEcharts style={{ height: "350px" }} option={this.FuelConsumption()} />
                    </Col>
                    <Col lg={4}>
                        <strong>In port</strong>
                        <ReactEcharts style={{ height: "350px" }} option={this.inPortOp()} />
                    </Col>
                    <Col lg={4}>
                        <strong>At sea</strong>
                        <ReactEcharts style={{ height: "350px" }} option={this.atSeaOp()} />
                    </Col>
                </Row>
            </React.Fragment>
        )
    }
}
export default FuelConsumptionChart;
